import styled from "styled-components"

function TubeConnections() {
  return (
    <TubeConnectionsWrapper>
      <img src="assets/imgs/tube.png" />
    </TubeConnectionsWrapper>
  )
}

export default TubeConnections

const TubeConnectionsWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: var(--primary);
  display: flex;
  justify-content: center;
  align-content: center;
  padding: 2%;
`
